import { LanguageType } from '@/custom-types';
import { ContractStatusOption, LeaseTermOption } from '@/graphql/generated';

export const contractStatusMapper = (status: ContractStatusOption, language: LanguageType) => {
  const statusMap = {
    en: {
      BOOKING: 'Booking',
      CANCELED: 'Canceled',
      EXPIRED: 'Expired',
      INITIATED: 'Initiated',
      NOT_ISSUED: 'Not Issued'
    },
    es: {
      BOOKING: 'Agendado',
      CANCELED: 'Cancelado',
      EXPIRED: 'Expirado',
      INITIATED: 'Iniciado',
      NOT_ISSUED: 'No Enviado'
    },
  };
  return statusMap[language][status];
};

export const contractLeaseTermMapper = (term: LeaseTermOption, language: LanguageType) => {
    const termMap = {
      en: {
        FIXED_TERM: 'Fixed Term',
        MONTH_TO_MONTH: 'Month to Month',
        YEARLY_TERM: 'Yearly Term'
      },
      es: {
        FIXED_TERM: 'Plazo Fijo',
        MONTH_TO_MONTH: 'Mensual',
        YEARLY_TERM: 'Anual'
      },
    };
    return termMap[language][term];
  };
